import request from '@/router/axios'
import env from '@/config/env'

/**
 * 隐私通话配置编辑
 * @param data
 */
export const privacyPhoneEdit = (data) => {
  return request({
    url: env.ferryUrl + '/privacyPhone/config/edit',
    method: 'POST',
    data
  })
}

/**
 * 获取隐私通话配置
 * @param data
 */
export const getPrivacyPhone = (data) => {
  return request({
    url: env.ferryUrl + '/privacyPhone/config',
    method: 'POST',
    data
  })
}

/**
 * 隐私通话配置日志
 * @param data
 */
export const privacyPhoneLog = (data) => {
  return request({
    url: env.ferryUrl + '/privacyPhone/config/log',
    method: 'POST',
    data
  })
}
